<!-- src/layouts/FrontLayout.vue -->
<!--App.vue-->
<template>
  <div id="app">
    <AppNavbar v-if="!$route.meta.hideNavFooter" />
    <!-- 內容區先佔一個畫面高度：資料還沒載入時頁尾不會先出現在畫面上、再被往下推（PageSpeed CLS 0.86 的主因） -->
    <div class="page-main">
      <router-view />
    </div>
    <AppFooter v-if="!$route.meta.hideNavFooter" />
  </div>
</template>

<script>
import AppNavbar from '@/components/__Navbar.vue';
import AppFooter from '@/components/__Footer.vue';

export default {
  name: 'App',
  components: {
    AppNavbar,
    AppFooter
  }
}
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

body.has-navbar {
  padding-top: 80px;
}

body.no-navbar {
  padding-top: 0;
}


#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 已開放手機縮放（無障礙）：輸入框至少 16px，避免 iPhone 點輸入框時畫面自動放大 */
@media (max-width: 768px) {
  input,
  select,
  textarea {
    font-size: 16px !important;
  }
}

.page-main {
  flex: 1 0 auto;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
}

/* 內容較短的頁面（如空購物車）讓頁面本身撐滿，不會留一段空白 */
.page-main > * {
  flex: 1 0 auto;
}

main,
.router-view {
  flex: 1;
  display: flex;
  flex-direction: column;
}

footer {
  text-align: center;
  padding: 20px 0;
  background-color: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  margin-top: auto;
}

.form-group input {
  font-size: 24px;
}

/* 讓 placeholder 也變大 */
.form-group input::placeholder {
  font-size: 24px;
  color: #aaa;
  /* 預設提示文字顏色 */
}

h1 {
  font-size: 2.0rem;
}

h2 {
  font-size: 1.8rem;
}

h3 {
  font-size: 1.5rem;
}

.step-indicator {
  font-size: 1.05rem;
}

label {
  font-size: 1.25rem;
}

input {
  font-size: 1.5rem;
}

button {
  font-size: 1.5rem;
}

.error-message {
  font-size: 1.5rem;
  color: red;
  margin-top: 5px;
}


@media (max-width: 768px) {
  .form-group input {
    font-size: 20px;
  }

  /* 讓 placeholder 也變大 */
  .form-group input::placeholder {
    font-size: 24px;
    color: #aaa;
    /* 預設提示文字顏色 */
  }
}

/* 文字 */
@media (max-width: 768px) {
  .register-card {
    flex-direction: column;
  }

  h1 {
    font-size: 2.0rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.5rem;
  }

  .step-indicator {
    font-size: 1.05rem;
  }

  label {
    font-size: 1.25rem;
  }

  input {
    font-size: 1.5rem;
  }

  button {
    font-size: 1.5rem;
  }

  .error-message {
    font-size: 1.25rem;
  }
}
</style>